import Link from "next/link";

const Arrow = () => (
  <svg
    className="h-5 w-5"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 5l7 7m0 0l-7 7m7-7H3"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    ></path>
  </svg>
);

const renderBlock = (
  { caption, head, subhead, buttonHref, buttonLabel },
  blockColor
) => {
  return (
    <div className={`color-block color-block__${blockColor}`}>
      <h5 className="ts-subheading mb-8">{caption}</h5>
      <h4 className="mb-8">{head}</h4>
      <h6 className="mb-8">{subhead}</h6>
      <Link
        href={buttonHref}
        className="ts-button ts-button--outline large block"
      >
        {buttonLabel}
        <Arrow />
      </Link>
    </div>
  );
};

const LearnMore = ({ block1, block2 }) => {
  return (
    <section className="learn-more mb-0">
      {renderBlock(block1, block1.blockColor || "accent-color-1")}
      {renderBlock(block2, block2.blockColor || "accent-color-2")}
    </section>
  );
};

export default LearnMore;
